// src/components/lead/sections/help/DashboardHelp.tsx

export function DashboardHelp() {
  return (
    <div className="text-blue-900">Org-level reporting and visibility (owner/admin).</div>
  );
}
